import * as React from 'react';
import styled from '@emotion/styled';
import { Text } from 'common/styledComponents/typography';

const Container = styled.div<{ isSticky: boolean }>`
  border-bottom: ${({ theme }) => `2px solid ${theme.colors.black.toString()}`};
  padding: ${({ theme }) => `${theme.space(4.5, 0, 3)}`};
  margin: ${({ theme }) => `${theme.space(0, 0, 4)}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  ${({ isSticky }) => (isSticky ? 'position: sticky; top: -2px; z-index: 100;' : '')}
`;

const FormHeaderActions = styled.div`
  display: flex;
  min-height: 48px;
  max-height: 48px;
`;

const Subtitle = styled.div`
  margin-top: ${({ theme }) => theme.space(1)};
  max-width: 640px;

  p {
    line-height: 2rem;
    font-weight: 500;
  }
`;

interface Props {
  title: string;
  subtitle?: string;
  /** Stay at the top while the content scrolls (default). Off, the header scrolls away with the page. */
  sticky?: boolean;
  children?: React.ReactNode;
}

const SettingsHeader: React.FC<Props> = ({ children, title, subtitle, sticky = true }) => {
  return (
    <Container isSticky={sticky}>
      <div>
        <Text variant='h4' color='black'>
          {title}
        </Text>
        {subtitle && (
          <Subtitle>
            <Text variant='body2' color='black50'>
              {subtitle}
            </Text>
          </Subtitle>
        )}
      </div>
      <FormHeaderActions>{children}</FormHeaderActions>
    </Container>
  );
};

export default React.memo(SettingsHeader);
